import { DOC_FRONTMATTER_DEFAULTS_BY_VERSION } from '../data/qlabVersions/doc-frontmatter-defaults';

export const getLdJson = (
  title: string,
  version: number,
  publishedOnForSEO?: string,
  updatedOnForSEO?: string,
) => {
  const versionDefaults = DOC_FRONTMATTER_DEFAULTS_BY_VERSION.find(
    (v) => v.version === version,
  );
  const pageUpdatedOn = updatedOnForSEO || versionDefaults?.updatedOnForSEO;
  const pagePublishedOn =
    publishedOnForSEO || versionDefaults?.publishedOnForSEO;

  if (pageUpdatedOn && pagePublishedOn) {
    return {
      '@context': 'https://schema.org',
      '@type': 'TechArticle',
      headline: title,
      datePublished: new Date(pagePublishedOn).toISOString(),
      dateModified: new Date(pageUpdatedOn).toISOString(),
    };
  }

  return undefined;
};
